import { createSelector } from "@reduxjs/toolkit";

import { extractMultilingualProperties } from "../../shared/index.ts";
import { nodeDesignsByIdSelector } from "../selectors/nodeDesignsCoreSelectors.ts";
import type { NodeDesignsState } from "../types.ts";

export const getNodeMultilingualPropertiesCreate =
  (designsById: NodeDesignsState["designsById"]) => (nodeOrId: { id: number } | number) => {
    const id = typeof nodeOrId === "number" ? nodeOrId : nodeOrId.id;
    return extractMultilingualProperties(designsById[id].config).map(({ path }) => path);
  };

export type GetNodeMultilingualProperties = ReturnType<typeof getNodeMultilingualPropertiesCreate>;

export const getNodeMultilingualPropertiesSelector = createSelector(nodeDesignsByIdSelector, (designsById) =>
  getNodeMultilingualPropertiesCreate(designsById),
);
